import { BaseModel } from "./BaseModel";


export default class WatershedGroupUser extends BaseModel {

    id: number;
    watershedGroupId: number;
    userID: string;
    active: number;
    editor: string;
    created: Date;
    updated: Date;

    constructor() {
        super("WatershedGroupUser", "local")
    }
}